<template>
  <fragment>
    <div
      class="card-on-card card-outline-secondary"
      id="placeholderLayoutMedia"
    >
      <content-placeholders :rounded="true">
        <div class="card-header">
          <h5 class="mb-2 font-weight-bold">Informasi Media</h5>
        </div>
        <div class="card-body">
          <content-placeholders-heading :img="true" />
          <content-placeholders-text :lines="4" />
        </div>
      </content-placeholders>
    </div>

    <div class="card-on-card card-outline-secondary" id="layoutMedia">
      <!-- Modal -->
      <div class="modal fade" id="imagePopup" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div
            class="modal-content"
            style="background-color: transparent; border: 0px"
          >
            <div
              class="modal-header"
              style="background-color: transparent; border: 0px"
            >
              <h5 class="modal-title" id="imagePopup"></h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                style="color: white"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" id="imagePopup"></div>
            <div class="modal-footer" style="border: 0px" id="imagePopup"></div>
          </div>
        </div>
      </div>
      <!-- End Modal -->
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold">Informasi Media</h5>
      </div>
      <div class="card-body text-center">
        <div class="row">
          <div class="pull-left ml-3">Foto Produk</div>
          <div class="col-12">
            <!-- Image Primary -->
            <div class="image-upload">
              <div class="image-edit">
                <input
                  type="file"
                  id="coverUpload"
                  class="imageUpload"
                  data-preview="imagePreview"
                  name="cover"
                  accept=".png, .jpg, .jpeg"
                />
                <label for="coverUpload" id="coverUploadLabel"></label>
              </div>
              <div class="preview zoom">
                <div id="imagePreview" :style="imagePrimary">
                  <span class="overlay"
                    ><i
                      id="fullscreen_logo_cover"
                      class="fa fa-arrows-alt fullscreen_logo_cover"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <div id="loader_image" class="align-content-center"></div>
                </div>
                <button
                  type="button"
                  id="removeCover"
                  class="btn btn-danger btn-sm"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>

              <div class="text-center mt-5">
                <label for="" class="">Foto Utama</label>
              </div>
            </div>
            <!-- Image array -->
            <fragment
              v-for="(other, index) in sectionMediaInformation.imageOther"
              :key="index"
            >
              <div class="image-upload">
                <div class="image-edit">
                  <input
                    type="file"
                    :id="
                      sectionMediaInformation.imageOther.length === 0
                        ? 'photoUpload1'
                        : 'photoUpload' + (index + 1)
                    "
                    :class="'imageUpload' + (index + 1)"
                    :data-preview="'photo' + (index + 1)"
                    :name="'photo' + (index + 1)"
                    accept=".png, .jpg, .jpeg"
                  />
                  <label :for="'photoUpload' + (index + 1)"></label>
                </div>
                <div class="preview zoom">
                  <div
                    :id="'photo' + (index + 1)"
                    :style="{ backgroundImage: 'url(' + other.image + ')' }"
                  >
                    <span class="overlay"
                      ><i class="fa fa-arrows-alt" aria-hidden="true"></i>
                    </span>
                  </div>
                  <button
                    type="button"
                    :id="'removePhoto' + (index + 1)"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="text-center mt-5">
                  <p for="" class="">Foto {{ index + 1 }}</p>
                </div>
              </div>
            </fragment>
            <!-- image added -->
            <div class="image-upload">
              <div class="image-edit">
                <input
                  type="file"
                  id="photoUpload3"
                  class="imageUpload"
                  data-preview="imagePreview1"
                  name="photo1[]"
                  accept=".png, .jpg, .jpeg"
                />
                <label for="photoUpload3"></label>
              </div>
              <div class="preview">
                <div id="imagePreview1" :style="imageSecondary"></div>
              </div>
              <button
                type="button"
                id="removePhoto"
                disabled
                class="btn btn-danger btn-sm"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
              <div class="text-center">
                <p for="" class="">Foto</p>
              </div>
            </div>
            <p class="text-muted text-left">
              Max. 500 kb Type file (gif,jpg,png,bmp)
            </p>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
// import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      countImage: 0,
    };
  },
  props: {
    isLayoutBook: Boolean,
    sectionMediaInformation: {},
    imgArray: {},
  },
  computed: {
    imagePrimary: function () {
      var bgImg = this.sectionMediaInformation.imagePrimary;
      return {
        background: "url(" + bgImg + ") no-repeat center",
        borderRadius: "5px",
        backgroundSize: "cover",
      };
    },
    imageSecondary: function () {
      var bgImg =
        "https://aosa.org/wp-content/uploads/2019/04/image-placeholder-350x350-300x300.png";
      return {
        background: "url(" + bgImg + ") no-repeat center",
        borderRadius: "5px",
        backgroundSize: "cover",
      };
    },
  },

  mounted: function () {
    $("#layoutMedia").hide();
    setTimeout(() => {
      this.countImage = this.sectionMediaInformation.imageOther;

      ("use strict");
      if (
        window.createObjectURL ||
        window.URL ||
        window.webkitURL ||
        window.FileReader
      ) {
        $(".browser").hide();
        $(".preview").children().show();
      }

      function isDataURL(s) {
        return !!s.match(isDataURL.regex);
      }

      function readURL(input) {
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          var preview = $(input).data("preview");
          var _invalid = $(input).parent().parent().find(".invalid-file");

          reader.onload = function (e) {
            if (isDataURL(e.target.result)) {
              _invalid.hide();
              $("#" + preview).css(
                "background-image",
                "url(" + e.target.result + ")"
              );
              $("#" + preview).hide();
              $("#" + preview).fadeIn(650);
            } else {
              $("#" + preview).hide();

              _invalid.html(
                '<div class="alert alert-danger"><strong>Error!</strong> Invalid image file.</div>'
              );
              _invalid.show();
            }
          };

          reader.readAsDataURL(input.files[0]);
        }
      }
      $(".imageUpload").bind("change", function (e) {
        e.preventDefault();
        readURL(this);
        $("#removeCover").css({
          "background-color": "#e64949",
        });
        $("#removeCover").removeAttr("disabled");
        $("#removePhoto").removeAttr("disabled");
      });

      for (let i = 1; i <= this.countImage.length; i++) {
        $(`.imageUpload${i}`).bind("change", function (e) {
          e.preventDefault();
          readURL(this);
          $("#removePhoto3").css({
            "background-color": "#e64949",
          });
          $("#removePhoto3").removeAttr("disabled");
        });
      }

      setTimeout(() => {
        document.getElementById("imagePreview").style.backgroundSize = "cover";
        $("#layoutMedia").show();
        $("#placeholderLayoutMedia").hide();
      }, 2000);

      $("#imagePreview").on("click", function () {
        var bg = $(this).css("background-image");
        //eslint-disable-next-line
        bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
        $("#imagePopup .modal-body").html(
          `<img src="${bg}"` +
            " width='50%' height='50%' class='clicked img-fluid rounded mx-auto d-block' onerror='imgError(this);'>"
        );
        $("#imagePopup").modal("toggle");
      });

      for (let i = 1; i <= this.countImage.length; i++) {
        $(`#photo${i}`).on("click", function () {
          var bg = $(this).css("background-image");
          //eslint-disable-next-line
          bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
          $("#imagePopup .modal-body").html(
            `<img src="${bg}"` +
              " width='100%' height='50%' class='clicked img-fluid img-container' onerror='imgError(this);'>"
          );
          $("#imagePopup").modal("toggle");
        });
      }

      $("#removeCover").on("click", function () {
        var imageUrl = `#e64949`;
        $("#imagePreview").css("background-image", "url(" + imageUrl + ")");
        $("#removeCover").css({
          "background-color": "grey",
        });
        $("#removeCover").attr("disabled", true);
      });

      $(`#removePhoto`).on("click", function () {
        var imageUrl = `#e64949`;
        $(`#imagePreview1`).css("background-image", "url(" + imageUrl + ")");
        $(`#removePhoto`).css({
          "background-color": "grey",
        });
        $(`#removePhoto`).attr("disabled", true);
      });

      for (let i = 1; i <= this.countImage.length; i++) {
        $(`#removePhoto${i}`).on("click", function () {
          var imageUrl = `#e64949`;
          $(`#photo${i}`).css("background-image", "url(" + imageUrl + ")");
          $(`#removePhoto${i}`).css({
            "background-color": "grey",
          });
          $(`#removePhoto${i}`).attr("disabled", true);
        });
      }
    }, 3000);
  },
};
</script>

<style scoped>
.avatar-upload,
.image-upload {
  display: inline-block;
  position: relative;
  max-width: 205px;
  margin: 15px 15px 15px 15px;
}

.avatar-upload .avatar-edit,
.image-upload .image-edit {
  position: absolute;
  z-index: 1;
}

.avatar-upload .avatar-edit {
  right: 12px;
  top: 10px;
}

.image-upload .image-edit {
  right: -13px;
  top: 10px;
}

.avatar-upload .avatar-edit input,
.image-upload .image-edit input {
  display: none;
}

.avatar-upload .avatar-edit input + label,
.image-upload .image-edit input + label {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  border-radius: 100%;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
}

.avatar-upload .avatar-edit input + label:hover,
.image-upload .image-edit input + label:hover {
  background: #f1f1f1;
  border-color: #d6d6d6;
}

.avatar-upload .avatar-edit input + label:after,
.image-upload .image-edit input + label:after {
  content: "\f040";
  font-family: "FontAwesome";
  color: #757575;
  position: absolute;
  top: 7px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}

.avatar-upload .preview,
.image-upload .preview {
  width: 140px;
  height: 170px;
  position: relative;
  border: 2px dashed #29354686;
  border-radius: 6px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}

.avatar-upload .preview {
  border-radius: 100%;
}

.avatar-upload .preview > div,
.image-upload .preview > div {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.avatar-upload .preview > div {
  border-radius: 100%;
}

.preview > div,
.invalid-file {
  display: none;
}

.error {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 100px;
  height: 120px;
  font-size: 1em;
  text-transform: capitalize;
  text-align: center;
  color: #fff;
  line-height: 1em;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}

.zoom {
  filter: brightness(100%);
  transition: transform 0.2s;
  /* Animation */
}

.zoom:hover {
  filter: brightness(70%);
  transform: scale(1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.zoom:hover span.overlay i {
  position: absolute;
  top: 40%;
  left: 0%;
  width: 100%;
  font-size: 2.25em;
  color: #fff !important;
  text-align: center;
  opacity: 1;
  -moz-opacity: 1;
  -webkit-opacity: 1;
  filter: alpha(opacity=1);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)";
}

.zoom span.overlay {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  height: 100%;
  width: 100%;
  background-color: rgb(46, 46, 46);
  opacity: 0;
  transition: opacity 0.25s ease-out;
  -moz-transition: opacity 0.25s ease-out;
  -webkit-transition: opacity 0.25s ease-out;
  -o-transition: opacity 0.25s ease-out;
}

/*Zoom Button and Tint Overlay*/
.zoom:hover span.overlay {
  display: block;
  visibility: visible;
  opacity: 0.55;
  -moz-opacity: 0.55;
  -webkit-opacity: 0.55;
  filter: alpha(opacity=65);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=65)";
}
</style>